import { Archive, AlertTriangle } from 'lucide-react'
import { FbModal as Modal } from '../../components/UI/Modal'

interface Props {
  show: boolean
  onHide: () => void
  campaignName: string
  isActive: boolean
  onConfirm: () => void
  isLoading: boolean
}

export function ArchiveCampaignModal({
  show,
  onHide,
  campaignName,
  isActive,
  onConfirm,
  isLoading,
}: Props) {
  return (
    <Modal
      open={show}
      onOpenChange={(open: boolean) => !open && onHide()}
      title="Archive Campaign"
      description={`Are you sure you want to archive "${campaignName}"?`}
      onAccept={onConfirm}
      acceptButtonText="Archive"
      loading={isLoading}
    >
      <div className="space-y-3">
        {isActive && (
          <div className="flex items-start gap-2.5 rounded-lg border border-warning-border bg-warning-bg p-3">
            <AlertTriangle className="mt-0.5 size-4 shrink-0 text-warning" />
            <p className="text-xs text-warning">
              This campaign is currently sending emails. Archiving will pause it
              first. You can unarchive later and manually resume.
            </p>
          </div>
        )}
        <div className="flex items-start gap-2.5 rounded-lg bg-surface-alt p-3">
          <Archive className="mt-0.5 size-4 shrink-0 text-fg-secondary" />
          <div>
            <p className="text-xs text-fg">
              Archived campaigns are hidden from the default view.
            </p>
            <p className="mt-1 text-xs text-fg-secondary">
              You can find them using the &quot;Archived&quot; filter and
              unarchive at any time.
            </p>
          </div>
        </div>
      </div>
    </Modal>
  )
}
